import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";

import { getFunctions } from "firebase/functions";

const config = {
  projectId: "enliv-342806",
  apiKey: "AIzaSyCWUzeZ7-Xf8fZCWJULHYDbc7poG4F3_ik",
  authDomain: "enliv-342806.firebaseapp.com",
};

const firebaseApp = initializeApp(config);
const auth = getAuth(firebaseApp);
const functionsInstance = getFunctions(firebaseApp, "us-east4");

export {
  auth,
  functionsInstance,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
  sendPasswordResetEmail,
  signInWithPopup,
  GoogleAuthProvider,
};
